import { Currency } from '../../constants/currency';
import { TERMS } from '../../constants/terms';
import type { Condition } from '../../hooks/useProductData';
import { generateTermRange, getAmountRangeToString, humanizeTermBestEdge } from '../humanization';
import { plur } from '../plur';

export const getCreditConditions = (item): Condition[] => {
  const conditions = [];

  const { sumFrom, sumTo, unitTo, minTermFrom, maxTermTo } = item;

  const amount = {
    from: sumFrom,
    to: sumTo,
  };

  const amountValue = getAmountRangeToString({ amountRange: amount, currency: Currency.RUB, isConvert: true });

  let term = null;

  if (['months', 'years'].includes(unitTo)) {
    const termRange = generateTermRange({
      dictDateFrom: TERMS[unitTo],
      dictDateTo: TERMS[unitTo],
      to: maxTermTo,
      from: minTermFrom,
    });

    term = humanizeTermBestEdge(termRange);
  } else if (minTermFrom && maxTermTo) {
    if (minTermFrom === maxTermTo) {
      term = `${minTermFrom} мес. – ${maxTermTo} ${plur({
        value: maxTermTo,
        unit: TERMS.years,
        initialForm: false,
      })}`;
    } else {
      term = `до ${maxTermTo} ${plur({
        value: maxTermTo,
        unit: TERMS.years,
        initialForm: false,
      })}`;
    }
  } else if (maxTermTo) {
    term = `до ${maxTermTo} ${plur({
      value: maxTermTo,
      unit: TERMS.years,
      initialForm: false,
    })}`;
  } else if (minTermFrom) {
    term = `от ${minTermFrom} ${plur({
      value: minTermFrom,
      unit: TERMS.months,
      initialForm: false,
    })}`;
  }

  conditions.push({ value: amountValue, description: 'Сумма' });
  conditions.push({ value: term, description: 'Срок' });

  return conditions;
};
